/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_5_3Inputs */



/**
* | output |
* | --- |
* | "Implementing a human-in-the-loop process for critical applications" |
*
* @param {Guardrails_Section_5_3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_5_3 = /** @type {((inputs?: Guardrails_Section_5_3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_5_3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Implementierung eines Human-in-the-Loop-Prozesses für kritische Anwendungen")
	return /** @type {LocalizedString} */ ("Implementing a human-in-the-loop process for critical applications")
});